<template>
  <div class="app">
    <!-- <Header /> -->
    <router-view id="child-container"/>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
// import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'Home',
  components: {
    // Header,
    Footer,
  },
};
</script>

<style lang="scss">

html {
  height: 100%;
}

body {
  width: inherit;
  height: 100%;
  margin: 0px;
}

.app {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
